import { LOG_EVENT_TYPES } from 'src/logger/event-types';
import { LOG_LEVEL } from 'src/logger/log-level';

/**
 * Mirror RUM transport filtering: debug never goes remote; info/warn only with
 * explicit eventType; errors always eligible.
 *
 * @param {Object} record
 * @returns {boolean}
 */
export const isOtlpLogEligible = (record) => {
    if (!record || record.level === LOG_LEVEL.DEBUG) {
        return false;
    }

    if (record.eventType) {
        return true;
    }

    if (record.level === LOG_LEVEL.ERROR) {
        return true;
    }

    return false;
};

/**
 * Resolve catalogued event type for generic errors without an explicit type.
 *
 * @param {Object} record
 * @returns {string|undefined}
 */
export const resolveOtlpEventType = (record) => {
    if (record?.eventType) {
        return record.eventType;
    }

    if (record?.level === LOG_LEVEL.ERROR) {
        return LOG_EVENT_TYPES.LOG_ERROR;
    }

    return undefined;
};
